import React, { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { frame_dev_top_n, frame_bottom, frame_dev_top1, card_dev1, card_dev2, card_dev3, frame_dev_top2, frame_dev_mid1, frame_dev_mid2, home_footer } from "../../../assets"

import { useNavigate } from 'react-router-dom';
import Contactus from '../../../sellers_module/components/dialog/contactus_dialog';
import "../../dev_pages/dev_home/dev_home.scss"

export default function DevHome() {
  const stepsData = {
    steps: [
      {
        bgColor: "#fff7f0",
        step: 1,
        description: "Create a new app in the Shiprocket App Store Panel and get the credentials",
        icon: card_dev1
      },
      {
        bgColor: "#f3f7ff",
        step: 2,
        description: "Plan and develop your app using Shiprocket's APIs, ensuring seamless integration with Shiprocket's functionalities.",
        icon: card_dev2
      },
      {
        bgColor: "#fffdec",
        step: 3,
        description: "Thoroughly test your app, adhering to Shiprocket's requirements for security & functionality.",
        icon: card_dev3
      },
      {
        bgColor: "#fff7f0",
        step: 4,
        description: "You’ll receive APIs, credentials and comprehensive development resources.",
        icon: 'https://d2kh7o38xye1vj.cloudfront.net/wp-content/uploads/2024/06/i8.svg'
      }
    ]
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true); // Open the dialog when the button is clicked
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog when needed
  };


  const Card: React.FC<CardProps> = ({ bgColor, step, description, icon, onMouseOver, onMouseOut }) => {
    return (
      <div
        style={{ backgroundColor: bgColor, }} // Set a fixed height for the card
        className="shadow-md rounded-xl p-4 flex flex-col justify-between w-full "
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        <div className="flex items-center space-x-4 h-16">
          <img src={icon} alt={`Step ${step} Icon`} className="w-10 h-10 object-contain" />
          <h2 className="text-blue-900 font-bold text-lg">Step {step}</h2>
        </div>
        <p className="text-gray-600 mt-2 flex-grow">{description}</p>
      </div>
    );
  };

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const animationFrameIdRef = useRef<number | null>(null);



  const scrollStep = () => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight) {
        scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(startScrolling, 500); // Restart scrolling after a short delay
      } else {
        scrollContainer.scrollBy({ top: 1, behavior: 'smooth' });
        animationFrameIdRef.current = requestAnimationFrame(scrollStep);
      }
    }
  };

  const startScrolling = () => {
    // if (animationFrameIdRef.current === null) {
    //   animationFrameIdRef.current = requestAnimationFrame(scrollStep);
    // }
  };

  const stopScrolling = () => {
    if (animationFrameIdRef.current !== null) {
      cancelAnimationFrame(animationFrameIdRef.current);
      animationFrameIdRef.current = null;
    }
  };

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    if (scrollContainer && scrollContainer.children.length > 3) {
      startScrolling();

      scrollContainer.addEventListener('mouseover', stopScrolling);
      scrollContainer.addEventListener('mouseout', startScrolling);
    }

    return () => {
      stopScrolling();
      if (scrollContainer) {
        scrollContainer.removeEventListener('mouseover', stopScrolling);
        scrollContainer.removeEventListener('mouseout', startScrolling);
      }
    };
  }, []);

  return (
    <div className="bg-[#f6f7fa] p-5 min-h-screen">
      <div style={{ borderRadius: "8px" }} className="bg-[#ffffff] p-4 pb-11">
        <div
          className="bg-no-repeat bg-cover bg-center w-full max-h-96 flex rounded-[10px] pl-10"
          style={{ backgroundImage: `url("${encodeURIComponent(frame_dev_top1)}")` }}
        >
          <div className="w-1/2 flex justify-center items-center">
            {/* Content for the first div */}
            <div>
              <div>
                <label style={{ fontFamily: "sfprobold", color: "white", fontSize: "38px" }}>
                  Integrate your app and&nbsp;
                </label>
                <label style={{
                  fontFamily: "sfprobold",
                  color: "white",
                  fontSize: "38px",
                  background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                  WebkitTextFillColor: 'transparent',
                  WebkitBackgroundClip: 'text',
                }}>
                  drive more revenue
                </label>
              </div>
              <div>
                <label style={{ fontFamily: "sfproregular", color: "white", fontSize: "14px", whiteSpace: 'pre-wrap', maxLines: "2" }}>
                  Grow your app’s presence in the eCommerce space, leveraging our global network and cutting-edge tools.
                </label>
              </div>
              <div>
                <button
                  onClick={() => {
                    navigate('/developer/createApps')
                  }}
                  style={{
                    background: "#735AE5",
                    border: "1px solid #00000000",
                    borderRadius: "8px",
                    opacity: 1,
                    padding: "10px 20px",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    fontSize: "20px",
                    fontWeight: "300",
                    fontFamily: "sfprobold",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                    width: "235px",
                  }}
                >
                  <a
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {"Create new app"}
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div className="w-1/2 flex justify-end items-end p-5">
            <div className="rounded shadow-md">
              {/* Content for the second div */}
              <img
                src={frame_dev_top2}
                alt="headerText"
              />
            </div>
          </div>
        </div>
        {/* 2top */}
        <div
          className="bg-no-repeat bg-cover bg-center w-full max-h-96 flex rounded-[10px] pl-10 pt-10 "
          style={{ backgroundImage: `url("${encodeURIComponent(frame_dev_mid1)}")`, }}
        >
          <div className="w-1/2 flex flex-col justify-start">
            {/* Content for the first div */}
            <div>
              <div>
                <label style={{ fontFamily: "sfprobold", color: "#0B0757", fontSize: "38px" }}>
                  Step to make&nbsp;
                </label>
                <label style={{
                  fontFamily: "sfprobold",
                  color: "white",
                  fontSize: "38px",
                  background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                  WebkitTextFillColor: 'transparent',
                  WebkitBackgroundClip: 'text',
                }}>
                  App Live
                </label>
              </div>
              <div style={{ width: "400px", height: "250px" }} className=''>
                <img

                  src={frame_dev_top_n}
                  alt="headerText"
                />
              </div>
            </div>
          </div>
          <div className="w-1/2 flex flex-col justify-start items-start  p-2.5 h-96">
            <div
              className="rounded overflow-auto h-full w-full flex flex-col space-y-4 no-scrollbar scroll-smooth"
              ref={scrollContainerRef}
            >
              {stepsData.steps.map((step) => (
                <Card
                  bgColor={step.bgColor}
                  key={step.step}
                  step={step.step}
                  description={step.description}
                  icon={step.icon}
                  onMouseOver={stopScrolling}
                  onMouseOut={startScrolling}
                />
              ))}
            </div>
          </div>
        </div>
      </div>








      <div
        className="bg-no-repeat bg-cover bg-center w-full max-h-96 flex rounded-[10px] pl-10 pt-10  mt-5"
        style={{ backgroundImage: `url("${(frame_dev_mid1)}")` }}
      >
        <div className="w-1/2 flex justify-center items-center ">
          {/* Content for the first div */}
          <div>
            <div>
              <label style={{ fontFamily: "sfprobold", color: "#0B0757", fontSize: "38px" }}>
                Resources&nbsp;
              </label>
            </div>
            <div>
              <label style={{ fontFamily: "sfproregular", color: "#828282", fontSize: "14px", whiteSpace: 'pre-wrap', maxLines: "2" }}>
                Creating and maintaining comprehensive API documentation is crucial for ensuring that developers can effectively use and integrate with an API.
              </label>
            </div>
            <div>
              <button
                style={{
                  background: "#735AE5",
                  border: "1px solid #00000000",
                  borderRadius: "8px",
                  opacity: 1,
                  padding: "10px 20px",
                  color: "#FFFFFF",
                  cursor: "pointer",
                  fontSize: "20px",
                  fontWeight: "300",
                  fontFamily: "sfprobold",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  width: "235px",
                }}
              >
                <a
                  href="https://documenter.getpostman.com/view/18002019/2sA35HZ2Vw"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {"API Doc"}
                </a>
              </button>
            </div>
          </div>
        </div>
        <div className="w-1/2 flex justify-end items-end p-5 ">
          <div className="rounded">
            {/* Content for the second div */}
            <img
              src={frame_dev_mid2}
              alt="headerText"
            />
          </div>
        </div>
      </div>




      <div style={{ borderRadius: "8px" }} className="bg-[#ffffff] p-4 mt-5">
        <div
          className="bg-no-repeat bg-cover bg-center w-full h-56 flex items-center justify-between rounded-[10px] pl-10 pr-10"
          style={{ backgroundImage: `url("${encodeURIComponent(frame_bottom)}")` }}
        >


          <div className='pl-5'>
            <label style={{ fontFamily: "sfprobold", color: "white", fontSize: "38px" }}>
              Want to talk&nbsp;
            </label>
            <label style={{
              fontFamily: "sfprobold",
              color: "white",
              fontSize: "38px",
              background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
              WebkitTextFillColor: 'transparent',
              WebkitBackgroundClip: 'text',
            }}>
              to the team?
            </label>
          </div>
          <div className="flex items-center">
            <button
              onClick={() => {
                handleOpenDialog()
              }}
              style={{
                background: "#ffffff",
                border: "1px solid #00000000",
                borderRadius: "8px",
                opacity: 1,
                padding: "10px 20px",
                color: "#000000",
                cursor: "pointer",
                fontSize: "20px",
                fontWeight: "300",
                fontFamily: "sfprobold",
                justifyContent: "center",
                alignItems: "center",
                width: "235px",
              }}
            >
              <a
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {"Contact Us"}
              </a>
            </button>
          </div>
          <Contactus
            open={dialogOpen}
            onClose={handleCloseDialog}
            onError={"Somthing went wrong"} // Pass error handler
            viewType={"web"}
          />
        </div>
      </div>



    </div>
  );





}
interface CardProps {
  step: number;
  bgColor: string;
  description: string;
  icon: string;
  onMouseOver: () => void;
  onMouseOut: () => void;
}
